/**
 * The address a page may send someone to after they sign in.
 *
 * `?next=` is read straight off the URL, so anyone can put anything in it. Only a path on this
 * site is honoured: one leading slash, no scheme, no host, no backslash tricks. Anything else,
 * including nothing at all, falls back to the page's own default.
 */
export const getSafeNextPath = (next: unknown, fallback: string): string => {
  if (typeof next !== 'string') return fallback;
  const candidate = next.trim();
  if (!candidate.startsWith('/')) return fallback;
  // "//evil.example" is a protocol-relative URL; "/\evil.example" is how some browsers read one.
  if (candidate.startsWith('//') || candidate.startsWith('/\\')) return fallback;
  // Escaped on purpose: literal control bytes here make git treat this file as binary, so the
  // diff cannot be reviewed, and one reformat that drops them leaves a plain hyphen match.
  if (/[\u0000-\u001f]/.test(candidate)) return fallback;
  return candidate;
};
